/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'blood pressure': {
    width: 16,
    height: 16,
    viewBox: '0 0 58.79 66.07',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M33.63 33.51a5.84 5.84 0 0 0 .52-.6l12.76-3.53-12.77-3.55a5.85 5.85 0 1 0-.52 7.68zM40.05 55.43c3.09-7.86-6.4-13-10.69-6.43-6-9.14-22.1 4.45 0 16.5a35 35 0 0 0 6.21-4.21M29.39.5v9.96M49.79 8.91l-7.04 7.04M9 8.94l7.04 7.04"/><path pid="1" class="cls-1" d="M16 42.78l-7 7a28.89 28.89 0 1 1 40.92 0l-7-7M.51 29.41h10.04"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/blood pressure.js